/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Hero_Voice_Comp_SciInputs */

const en_homepage_hero_voice_comp_sci = /** @type {(inputs: Homepage_Hero_Voice_Comp_SciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comp Sci`)
};

const es_homepage_hero_voice_comp_sci = /** @type {(inputs: Homepage_Hero_Voice_Comp_SciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informática`)
};

/**
* | output |
* | --- |
* | "Comp Sci" |
*
* @param {Homepage_Hero_Voice_Comp_SciInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_hero_voice_comp_sci = /** @type {((inputs?: Homepage_Hero_Voice_Comp_SciInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Hero_Voice_Comp_SciInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_hero_voice_comp_sci(inputs)
	return en_homepage_hero_voice_comp_sci(inputs)
});